const lang = {
  title: '表紙情報を入力',
  work_content: '作業内容',
  control_number: '管理番号',
  delivery_name: '納入先名',
  please_enter: '入力してください',
  working_day: '作業日',
  start_work: '着工',
  completion: '竣工',
  contractor_name: '施工者名',
  enter_item_name: '項目名を入力',
  please_select_date: '日付を選択してください'
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/daikinCoverReport.js